<template>
  <div class="developer-form">
    <return-button class="mb-4" @click="$emit('close')"></return-button>
    <form @submit.prevent="$emit('add', developer)">
      <div class="flex-sb-adaptive">
		<form-group label="Удалить" class="mb-4">
      		<delete-button type="button" @click="$emit('archive', developer)"></delete-button>
    	</form-group>
        <form-group label="Название" class="mb-4">
          <custom-input type="text" v-model="developer.title" disabled />
        </form-group>
        <form-group label="Имя" class="mb-4">
          <custom-input type="text" v-model="developer.fullName" disabled />
        </form-group>
      </div>
      <div class="flex-sb-adaptive">
        <form-group label="Организация" class="mb-4">
          <custom-input type="text" v-model="developer.organization" disabled />
        </form-group>
        <form-group label="Отдел" class="mb-4">
          <custom-input type="text" v-model="developer.department" disabled />
        </form-group>
      </div>
      <div class="flex-sb-adaptive">
        <form-group label="Страна" class="mb-4">
			<custom-input type="text" v-model="developer.Country.nameRu" disabled />
        </form-group>
        <form-group label="Город" class="mb-4">
          <custom-input type="text" v-model="developer.city" disabled />
        </form-group>
        <form-group label="Штат" class="mb-4">
          <custom-input type="text" v-model="developer.state" disabled />
        </form-group>
      </div>
    </form>
  </div>
</template>

<script>
  import ReturnButton from './UIComponents/ReturnButton';
  import RButton from './UIComponents/RButton';
  import Select2 from './UIComponents/Select2';
  import FormGroup from './UIComponents/FormGroup';
  import CustomInput from './UIComponents/CustomInput';
  import deleteButton from './UIComponents/DeleteButton';

  export default {
    components: {
      ReturnButton,
      RButton,
      Select2,
      FormGroup,
	  CustomInput,
	  deleteButton
    },
    props: {
      developer: Object
    }
  }
</script>

<style lang="scss" scoped>
.developer-form {
  max-width: 900px;
  margin: 0 auto;

  &__error {
    width: 100%;
    height: 100px;
    overflow-y: auto;
  }
}
</style>